import * as React from "react"
// @ts-ignore
import anime from "animejs";
import { TitleCmp } from "../config/interfaces";

const animations: any = {
    default: {
        targets: '.word-split .word-split__char',
        translateX: [50, 0],
        opacity: [0, 1],
        duration: 3000,
        delay: function (_: any, i: any) {
            return i * 100
        }
    },
    fadeUp: {
        targets: '.word-split .word-split__char',
        translateY: [50, 0],
        opacity: [0, 1],
        duration: 2000,
        delay: function (_: any, i: any) {
            return i * 70
        }
    }
}

export default ({ text, type = 'default' }: TitleCmp) => {
    const [title, setTitle] = React.useState<any>([])

    const splitText = (fullText: string) => {
        return fullText.split(' ')
    }

    const splitWord = (word: string) => {
        return word.split('')
    }

    React.useEffect(() => {
        let letters: any = [];
        let splitFullText = splitText(text)
        splitFullText.forEach((word: string) => {
            letters.push(splitWord(word))
        });
        Promise.resolve()
            .then(() => {
                setTitle(letters)
            })
            .then(() => {
                anime(animations[type])
            })
    }, [text])

    if (title.length == 0) return <div className="word-split">{text}</div>

    return (
        <React.Fragment>
            {title.map((word: Array<string>, indexWord: number) => (
                <div className="word-split" key={indexWord}>
                    {word.map((letter: string, indexLetter: number) => (
                        <span key={indexLetter} className="word-split__char">{letter}</span>
                    ))}
                </div>
            ))}
        </React.Fragment>
    )
}